import styled, { keyframes } from 'styled-components';
import {
  Table,
} from 'reactstrap';

export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const FormSection = styled.div`
  display: flex;
  width: 723px;
  flex-direction: row;
  gap: 30px;
`;

export const TuitionContainer = styled.div`
  padding: 20px;
  animation: ${fadeIn} 0.5s ease-out;
`;
export const StyledTable = styled(Table)`
  border: 0.8px solid #000 !important; /* Tăng độ đậm của viền */
  th,
  td {
    border: 0.8px solid #000 !important; /* Tăng độ đậm viền các ô */
  }
`;

export const SuccessButton = styled.button`
  padding: 8px 16px;
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
  transition: all 0.3s ease;
  margin-bottom: 10px;
  
  &:hover {
    background: linear-gradient(135deg, #20c997, #28a745);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(40, 167, 69, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    background: linear-gradient(135deg, #6c757d, #545b62);
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;